import React from "react";
import MainSection from "../containers/MainSection";
import Header from "../containers/Header";

const App = () => {
  return (
    <div>
      <Header />
      <MainSection />
    </div>
  );
};

export default App;
